<template>
    <validation-provider
    :name="validatorName"
    :rules="rules"
    v-slot="validationContext"
    style="display: block; width: max-content;"
    >
        <label :for="id">{{label}} <span class="additonal-msg">{{additionalMsg}}</span></label>
        <b-row>
            <b-col
              md="6">
                <b-form-select 
                    :id="id"
                    :name="name"
                    :state="getValidationState(validationContext)"
                    :options="options"
                    :aria-describedby="description"
                    @change="changeInput($event, validationContext)"
                    v-model="value"
                    class="custom-select"
                    :size="size"
                    :disabled=disabled
                    :multiple=multiple
                >
                </b-form-select>
            </b-col>
            <b-col
              md="6">
                <b-form-select 
                    :id="id2"
                    :name="name2"
                    :state="getValidationState(validationContext)"
                    :options="options2"
                    :aria-describedby="description"
                    @change="changeInput2($event, validationContext)"
                    v-model="valuetwo"
                    class="custom-select"
                    :size="size2"
                    :disabled=disabled
                    :multiple=multiple
                >
                </b-form-select>
            </b-col>
        </b-row>
        <b-form-invalid-feedback :id="description">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
    </validation-provider>
</template>

<script>
export default {
    props : {
        id: String,
        id2: String,
        name: String,
        name2: String,
        label: String,
        description: String,
        validatorName: String,
        rules:{
            required: Boolean,
            min: Number
        },
        additionalMsg: String,
        options: Array,
        options2: Array,
        modelValue1: String,
        modelValue2: String,
        disabled:Boolean,
        size: String,
        size2: String,
        multiple: Boolean
    },
    methods:{
        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        },
        changeInput: async function (value,{validate}) {
          await this.updateinput(value,validate);
        //other logic not relevant to the issue
        },
        changeInput2: async function (valuetwo,{validate}) {
          await this.updateinput2(valuetwo,validate);
        //other logic not relevant to the issue
        },
        async updateinput(value,validate) {
            await validate(value);
        },
        async updateinput2(valuetwo,validate2) {
            await validate2(valuetwo);
        }
    },
    computed:{
        value: {
            get() {
                return this.modelValue1
            },
            set(value) {
                this.$emit('update:modelValue1', value)
            }
        },
        valuetwo: {
            get() {
                return this.modelValue2
            },
            set(value) {
                this.$emit('update:modelValue2', valuetwo)
            }
        }
    }
}
</script>

<style>
 .additonal-msg{
     font-size: 11px;
    color: #b32649;
 }
 .custom-select{
    display: inline-block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 1.75rem 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    vertical-align: middle;
    background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>"); 
    background-repeat: no-repeat;
    background-position-x: 100%;
    background-position-y: 5px;
    background-size: auto;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin-bottom: 10px;
 }
</style>